module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-1-fa255c2b922f874a5df9ef545b5c37a4.jpg";